<template>
  <div class="submit-form">

    <hLargeIconHeader text="Add Survey" :icon="'file-plus'"></hLargeIconHeader>

    <div v-if="!submitted">
      <div class="form-group mt-4">
          <h4>Config:</h4>
        <div>
          <textarea
            type="text"
            rows="10"
            cols="80"
            class="code-block"
            id="config"
            required
            v-model="survey.config"
            name="config"
          />
        </div>
      </div>

      <button @click="saveSurvey" class="btn btn-success">Submit</button>
    </div>

    <div v-else>
      <h4>{{ submitMessage }}</h4>
      <div v-if="!submitError && surveyUrl" class="mt-2">
        <a :href="surveyUrl">{{ surveyUrl }}</a>
      </div>
        <div v-if="submitError && submitErrorDetail" class="mt-2 code-block error-detail">{{ submitErrorDetail }}</div>
      <div class="mt-3">
        <button class="btn btn-success" @click="newSurvey">{{ submitError ? "Try again" : "Add one more Survey" }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import SurveyDataService from "../services/SurveyDataService";

import hLargeIconHeader from "./h/hLargeIconHeader";

export default {
  name: "add-survey",
  components: {
    hLargeIconHeader
  },
  data() {
    return {
      survey: {
        id: null,
        title: "",
        config: "",
        published: false
      },
      submitted: false,
      submitError: false,
      submitMessage: "",
      submitErrorDetail: "",
      surveyUrl: ""
    };
  },
  methods: {
    getErrorDetail(error) {
      if (error && error.response && error.response.data) {
        if (typeof error.response.data === "string") {
          return error.response.data;
        }
        if (error.response.data.message) {
          return error.response.data.message;
        }
        return JSON.stringify(error.response.data);
      }

      if (error && error.message) {
        return error.message;
      }

      return "Unknown error";
    },
    saveSurvey() {
      var data = this.survey.config;

      this.submitError = false;
      this.submitMessage = "";
      this.submitErrorDetail = "";
      this.surveyUrl = "";

      SurveyDataService.create(data)
        .then(response => {
          const createdSurvey = response && response.data ? response.data : null;
          const surveyId = createdSurvey && (createdSurvey._id || createdSurvey.id);

          if (!createdSurvey || !surveyId) {
            this.submitError = true;
            this.submitMessage = "Something went wrong";
            this.submitErrorDetail = "Survey response was missing the survey object or survey id.";
            this.submitted = true;
            return;
          }

          this.survey.id = surveyId;
          this.survey.config = createdSurvey.config;
          this.submitError = false;
          this.submitMessage = "Survey successfully added!";
          this.surveyUrl = window.location.origin + "/surveys/" + surveyId;
          this.submitted = true;
          console.log(response.data);
        })
        .catch(e => {
          console.log(e);
          this.submitError = true;
          this.submitMessage = "Something went wrong";
          this.submitErrorDetail = this.getErrorDetail(e);
          this.submitted = true;
        });
    },

    newSurvey() {
      this.submitted = false;
      this.submitError = false;
      this.submitMessage = "";
      this.submitErrorDetail = "";
      this.surveyUrl = "";
      this.survey = {
        id: null,
        title: "",
        config: "",
        published: false
      };
    }
  }
};
</script>

<style>
.submit-form {
  max-width: 1300px;
  margin: auto;
}
.code-block {
  font-family: monospace, Arial, sans-serif;
  font-size: smaller;
  background: #ddd;
  color: #666;
}
.error-detail {
  display: inline-block;
  padding: 8px 10px;
  white-space: pre-wrap;
}
</style>